@if (data(); as data) {
	@if (data.after && !data.before) {
		@if (upsertMode()) {
			<nz-tag
				[nzColor]="BEFORE_AFTER_STATUS_UPSERT_COLOR"
				[nz-tooltip]="
					'Row will be created if it does not already exist,' +
					' it will be updated if it does exist. ' +
					' For rows containing an email address (or school ID) duplicates will be prevented by looking up the unique identifier first.'
				"
			>
				{{ SetupWizardPreviewStatus.UPSERT }}
			</nz-tag>
		} @else {
			<nz-tag [nzColor]="BEFORE_AFTER_STATUS_NEW_COLOR" nz-tooltip="Row will be created.">
				{{ SetupWizardPreviewStatus.NEW }}
			</nz-tag>
		}
	} @else if ((data.after && data.before) || hasEnrollmentChanged()) {
		<nz-tag [nzColor]="BEFORE_AFTER_STATUS_CHANGED_COLOR" nz-tooltip="Row will be updated.">
			{{ SetupWizardPreviewStatus.CHANGED }}
		</nz-tag>
	} @else if (data.before) {
		<nz-tag [nzColor]="BEFORE_AFTER_STATUS_UNCHANGED_COLOR" nz-tooltip="Row is unchanged.">
			{{ SetupWizardPreviewStatus.UNCHANGED }}
		</nz-tag>
	}
}
